module.exports = __webpack_public_path__ + "static/media/VeevaErrorIcon.a7f72676.svg";